import { Injectable } from '@angular/core';
import { Payment } from '../models/payment';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt';
import { RequestOptions, Headers } from '@angular/http';
import { List } from 'immutable';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class PaymentHttpService {

  private eventsUrl: string = this.environment.baseUrl + '/api/events';
  private paymentUrl: string = this.eventsUrl + '/payments';

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  add(payment: Payment): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.paymentUrl, JSON.stringify(payment.toJS()), options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getPayments(eventId: number): Observable<List<Payment>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/payments`)
      .map(response => List(response.json().map(element => new Payment(element))))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getLatestPayment(eventId: number): Observable<Payment> {
    return this.http.get(`${this.eventsUrl}/${eventId}/latestPayment`)
      .map(response => {
        const data = response.json();
        return new Payment(data);
      })
      .catch(ResponseUtil.unwrapErrorMessage)
      .share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/payment.http.service.ts